import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';
import type { WithAttributes } from '@pega/cosmos-react-core';

const StyledHorizontalRule = styled.hr(
  ({ theme }) => css`
    /* stylelint-disable-next-line unit-allowed-list */
    margin-block: calc((1lh - 0.0625rem) / 2);
    border: none;
    border-block-start: 0.0625rem solid ${theme.base.palette['border-line']};
    height: 0;
  `
);

StyledHorizontalRule.defaultProps = defaultThemeProp;

type HorizontalRuleProps = WithAttributes<'hr', { children?: never }>;

const HorizontalRule = ({ children, ...restProps }: HorizontalRuleProps) => {
  return <StyledHorizontalRule {...restProps} />;
};

export default HorizontalRule;
